import { Component, OnInit } from '@angular/core';
import { Globals } from "../../_models/globals";
import { User } from "../../_models/user";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";
import { AlertService } from '../../_services/alert.service';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { ApiIntegration } from '../../_services/api.integration';

@Component({
  selector: 'app-admin-manage-dunzo',
  templateUrl: './admin-manage-dunzo.component.html',
  styleUrls: ['./admin-manage-dunzo.component.scss'],
})
export class AdminManageDunzoComponent implements OnInit {
  dunzoList: any = {};
  carrierId: any;
  carrierNameError: string;
  clientSecretError: string;
  clientIdError: string;

  constructor(private api: ApiIntegration, private alertService: AlertService, private g: Globals, private user: User, private http: HttpClient, private router: Router, private route: ActivatedRoute) {
    this.carrierId = this.route.snapshot.paramMap.get('id');
    if (this.carrierId) {
      this.api.adminGetCarrierInfoById(this.carrierId, this.user.organizationId).subscribe((data: any) => {
        this.dunzoList = data;
      }, err => {
        this.alertService.error('Error', err);
      });
    }
  }
  carrierNameBlur() {
    this.carrierNameError = "";
    if (!this.dunzoList.connectionName) {
      this.carrierNameError = 'Please enter carrier name';
    }
  }

  clientSecretBlur() {
    this.clientSecretError = "";
    if (!this.dunzoList.clientSecret) {
      this.clientSecretError = 'Please enter clientSecret';
    }
  }

  clientIdBlur() {
    this.clientIdError = "";
    if (!this.dunzoList.clientId) {
      this.clientIdError = 'Please enter clientId';
    }
  }


  ngOnInit() { }

  verify() {

    this.g.loaderDisplay = "display";
    this.carrierNameError = "";
    this.clientIdError = "";
    this.clientSecretError = "";

    if (!this.dunzoList.connectionName) {
      this.carrierNameError = 'Please enter carrier name';
    }
    if (!this.dunzoList.clientSecret) {
      this.clientSecretError = 'Please enter clientSecret';
    }
    if (!this.dunzoList.clientId) {
      this.clientIdError = 'Please enter clientId';
    }
    if (this.carrierNameError != "" || this.clientSecretError != "" || this.clientIdError != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    // api body

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateCarrierCredentials', {

      "carrierCode": this.dunzoList.carrierCode,
      "connectionName": this.dunzoList.connectionName,
      "organizationId": this.dunzoList.organizationId,
      "clientId": this.dunzoList.clientId,
      "clientSecret": this.dunzoList.clientSecret,
      "carrierId": this.dunzoList.carrierId
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Dunzo', 'Create Successfully');
          this.router.navigate(['/admin/adminCarriers']);
        }
        else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          console.log(err);
        })
  }
}
